import { render } from "./Profile-Own.vue?vue&type=template&id=0209ca41"
import script from "./Profile-Own.vue?vue&type=script&lang=js"
export * from "./Profile-Own.vue?vue&type=script&lang=js"

import "./Profile-Own.vue?vue&type=style&index=0&id=0209ca41&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__